export function regulationDocuments(t) {
  return [
    { title: t.pdfTitle, subtitle: t.pdfSubtitle, url: t.pdfUrl },
    {
      title: t.fullPolicyTitle,
      subtitle: t.fullPolicySubtitle,
      url: t.fullPolicyUrl,
    },
    { title: t.manualTitle, subtitle: t.manualSubtitle, url: t.manualUrl },
    { title: t.priceTitle, subtitle: t.priceSubtitle, url: t.priceUrl },
  ];
}
